import { render, staticRenderFns } from "./IncomeStatementView.vue?vue&type=template&id=6fec16e3"
import script from "./IncomeStatementView.vue?vue&type=script&lang=js"
export * from "./IncomeStatementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports